/**
 * EventDeviceCell — an event row's device: the name, linked by the alert rule
 * (getAlertDeviceLink: the device profile, or the server profile for a server-offline
 * event at weight 80+), with the serial (manufacture_uuid) underneath when there is one.
 *
 * Shared by the Alert Details and Executive report tables (docs/DUPLICATION_AUDIT.md,
 * B17). The profile Reporting tabs link the whole block in their own field style, so
 * they keep their own cell.
 *
 * @param {object} row — description, manufacture_uuid, and the link fields
 * @param {string} [fallback] — text when there is no description
 */

import { Link } from 'react-router-dom';
import { getAlertDeviceLink } from '../../utils/deviceLinks.js';
import { getRoleWeight } from '../../services/session.js';

const EventDeviceCell = ({ row, fallback = '—' }) => {
    const deviceLink = getAlertDeviceLink(row, getRoleWeight());
    const label = row.description || fallback;
    return (
        <div>
            {deviceLink
                ? <Link to={deviceLink} className="dp-link">{label}</Link>
                : <span className="dp-cell-text">{label}</span>}
            {row.manufacture_uuid ? (
                <span className="dp-cell-text dp-cell-text--muted" style={{ display: 'block', fontSize: 'var(--font-size-xs)' }}>
                    {row.manufacture_uuid}
                </span>
            ) : null}
        </div>
    );
};

export default EventDeviceCell;
